export default __webpack_public_path__ + "static/media/Ballroll_00310.5fb26a3a.png";